import { GoodgameSignal } from "./GoodgameSignal";

import Point = createjs.Point;

/**
 *    PointSignal
 *
 *     @author Alexander
 */

export class PointSignal extends GoodgameSignal {
    constructor() {
        super(Point);
    }

    public signal(point: Point): void {
        super.dispatch(point);
    }
}
